import {useEffect} from "react";
import {css} from "@emotion/react";

import {p} from "@pg-design/helpers-css-strings";
import {Modal} from "@pg-design/modal-module";
import {getThemeBreakpoint} from "@pg-design/styles-strings";
import {useUserDevice} from "@pg-mono/user-device";

import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {closeForYouModal} from "../state/for_you_modal_slice";
import {ForYouModalContent} from "./modal_parts/ForYouModalContent";
import {ForYouModalHeading} from "./modal_parts/ForYouModalHeading";

export const ForYouModal = () => {
    const modalState = useAppSelector((state) => state.forYouModal);
    const dispatch = useAppDispatch();
    const {isMobile} = useUserDevice();

    useEffect(() => {
        if (modalState.isModalOpen && isMobile) {
            document.body.style.overflow = "hidden";
        }

        if (!modalState.isModalOpen && isMobile) {
            document.body.removeAttribute("style");
        }
    }, [modalState.isModalOpen]);

    const onModalClose = () => {
        dispatch(closeForYouModal());
    };

    return (
        <Modal isOpen={modalState.isModalOpen} css={modalStyle} onModalClose={onModalClose}>
            <Modal.Header as="div" showCloseButton={false}>
                <ForYouModalHeading onModalClose={onModalClose} />
            </Modal.Header>
            <Modal.Content className="modal-content">
                <ForYouModalContent />
            </Modal.Content>
        </Modal>
    );
};

const modalStyle = css`
    .modal-content {
        ${p(0)};
    }

    @media (min-width: ${getThemeBreakpoint().sm}) {
        max-width: 840px;
        width: 100%;
    }
`;
import {useEffect} from "react";
import {css} from "@emotion/react";

import {p} from "@pg-design/helpers-css-strings";
import {Modal} from "@pg-design/modal-module";
import {getThemeBreakpoint} from "@pg-design/styles-strings";
import {useUserDevice} from "@pg-mono/user-device";

import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {closeForYouModal} from "../state/for_you_modal_slice";
import {ForYouModalContent} from "./modal_parts/ForYouModalContent";
import {ForYouModalHeading} from "./modal_parts/ForYouModalHeading";

export const ForYouModal = () => {
    const modalState = useAppSelector((state) => state.forYouModal);
    const dispatch = useAppDispatch();
    const {isMobile} = useUserDevice();

    useEffect(() => {
        if (modalState.isModalOpen && isMobile) {
            document.body.style.overflow = "hidden";
        }

        if (!modalState.isModalOpen && isMobile) {
            document.body.removeAttribute("style");
        }
    }, [modalState.isModalOpen]);

    const onModalClose = () => {
        dispatch(closeForYouModal());
    };

    return (
        <Modal isOpen={modalState.isModalOpen} css={modalStyle} onModalClose={onModalClose}>
            <Modal.Header as="div" showCloseButton={false}>
                <ForYouModalHeading onModalClose={onModalClose} />
            </Modal.Header>
            <Modal.Content className="modal-content">
                <ForYouModalContent />
            </Modal.Content>
        </Modal>
    );
};

const modalStyle = css`
    .modal-content {
        ${p(0)};
    }

    @media (min-width: ${getThemeBreakpoint().sm}) {
        max-width: 840px;
        width: 100%;
    }
`;
